import { classNames } from '@shopify/css-utilities'
import { useServerProps } from '@shopify/hydrogen'
import { AnimatePresence, motion } from 'framer-motion'
import styles from '../assets/scss/components/progress-bar.module.scss'

export const ProgressBar: React.FC<{ variant?: string }> = ({ variant }) => {
  const { pending } = useServerProps()

  return (
    <>
      <AnimatePresence initial={false}>
        {pending && (
          <motion.div
            animate={{ width: '100%' }}
            className={classNames(styles.progressBar, variant && styles[variant])}
            initial={{ width: 0 }}
            transition={{ duration: 5, ease: [0, 0, 0, 1] }}
          />
        )}
      </AnimatePresence>
    </>
  )
}
